@if (isDesign) {
  <fb-medical-notes-widget-placeholder />
} @else if (isPrinting) {
  <fb-medical-notes-widget-print [data]="data()" [isTemplatePrint]="isTemplatePrint" />
} @else if (isPreview || isEmrReadonly) {
  <fb-medical-notes-widget-preview [data]="data()" [isEmrReadonly]="isEmrReadonly" />
} @else {
  <fb-medical-notes-widget-edit
    [data]="data()"
    [patientRemoteId]="patientRemoteIdValue()"
    [appointmentId]="appointmentIdValue()"
    [markerTargets]="getScribeMarkerTargets()"
    (update)="updatePayload($event)"
  />
}
